import {connect} from 'react-redux';
import {connectLanguage} from '../../utils/connectLanguage';
import ThankYouComponent from './ThankYou.js';

export default connectLanguage(ThankYouComponent, connect);
